const formatDate = (dateString?: string | null) => {
  if (!dateString) {
    return null;
  }

  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export default formatDate;
